module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_weekendsale_small_en-96875febe50177a9d2527c85b7b3855b.jpg";